import { General } from '@atomickit/atomickit-constants';

import { BusinessProfile } from '@shared/meta-data/business-profile.meta';

export function isUsageBasedStripeBilling(profile: BusinessProfile | null | undefined): boolean {
  return profile?.billing_model === 'usage_based_stripe';
}

/**
 * Legacy Reporting subscription (SUBSCRIBED) was required before AutoRegister / AutoFiling pay flows.
 * Usage-based merchants bill via Stripe and do not use that gate.
 */
export function shouldBlockFeatureWithoutReportingSubscription(profile: BusinessProfile | null | undefined): boolean {
  if (!profile) {
    return false;
  }
  if (isUsageBasedStripeBilling(profile)) {
    return false;
  }
  return profile.account_status !== General.ACCOUNT_STATUS.SUBSCRIBED;
}
